/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitesubexpiredbtnok4Inputs */



/**
* | output |
* | --- |
* | "OK" |
*
* @param {Invitesubexpiredbtnok4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const invitesubexpiredbtnok4 = /** @type {((inputs?: Invitesubexpiredbtnok4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitesubexpiredbtnok4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("OK")
	if (locale === "es") return /** @type {LocalizedString} */ ("OK")
	return /** @type {LocalizedString} */ ("Ок")
});
export { invitesubexpiredbtnok4 as "inviteSubExpiredBtnOk" }